import FetchSettings from "../../interfaces/FetchSettings";
import { MonthlyThemePage } from "../../interfaces/MonthlyTheme";
import OcontentProvider from "./OcontentProvider";

export default class OcontentMonthlyThemeProvider extends OcontentProvider {
  protected _baseUrl = this.baseUrl + "monthly-theme/";

  async getPage(filename: string): Promise<MonthlyThemePage | null> {
    try {
      const url = new URL(this._baseUrl + filename + ".json");
      const settings: FetchSettings = {
        method: "GET",
      };

      const res = await this.request<Response>(url.toString(), settings, true);
      return res.ok ? await res.json() : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
